import { useEffect, useRef, useState } from "react";
import "./Rejected_link.css";

import { useSSE } from "../SSE/SSEProvider";

// const API_BASE = "http://192.168.1.103:8081";

export default function Rejected_links() {
  const { componentEvent } = useSSE("Rejected_links");
  const [rejectedLinks, setRejectedLinks] = useState([]);
  const [loading, setLoading] = useState(true);

  const [selectedRow, setSelectedRow] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // League mapping floating panel
  const [showMapping, setShowMapping] = useState(false);
  const API_URL = process.env.REACT_APP_DIRECT || "http://192.168.1.103:8081";
  const FAST_AP_LINK = process.env.REACT_APP_API_FAST || "http://192.168.1.103:8000";

  // Dragging state
  const [mappingPosition, setMappingPosition] = useState({
    x: null,
    y: null,
  });

  const modalRef = useRef(null);
  const mappingRef = useRef(null);

  const dragData = useRef({
    dragging: false,
    offsetX: 0,
    offsetY: 0,
  });

  const [formData, setFormData] = useState({
    team_code: "",
    country: "",
    league: "",
    normalized: "",
    dom_short: "",
    inclusion: false,
  });

  // =========================================================
  // FETCH REJECTED LINKS
  // =========================================================

  useEffect(() => {
    fetchRejectedLinks();
  }, [componentEvent]);

  const fetchRejectedLinks = async () => {
    try {
      setLoading(true);

      const response = await fetch(`${API_URL}/table1/rejected_links`);

      if (!response.ok) {
        throw new Error("Failed to fetch rejected links");
      }

      const data = await response.json();
      console.log("data_is__", data);

      setRejectedLinks(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error fetching rejected links:", error);

      setRejectedLinks([]);
    } finally {
      setLoading(false);
    }
  };

  //-----------------------------
  const handleDeleteAll = async () => {
    const confirmed = window.confirm(
      "Are you sure you want to delete ALL league mappings?\n\nThis action cannot be undone."
    );

    if (!confirmed) {
      return;
    }

    try {
      const response = await fetch(
        `${FAST_AP_LINK}/reset_league_mappings/json_data`,
        {
          method: "DELETE",
        }
      );

      if (!response.ok) {
        throw new Error("Failed to delete all league mappings");
      }

      await fetchRejectedLinks();
    } catch (error) {
      console.error("Error deleting all league mappings:", error);
    }
  };
  // =========================================================
  // OPEN MODAL
  // =========================================================

  const handleOpenModal = (row) => {
    setSelectedRow(row);

    setFormData({
      team_code: row?.team_code || "",
      country: row.country || "",
      league: row.league || "",
      normalized: row.normalized || "",
      dom_short: row.dom_short || "",
      inclusion: false,
    });

    setShowMapping(false);

    setMappingPosition({
      x: null,
      y: null,
    });

    setShowModal(true);
  };

  // =========================================================
  // CLOSE MODAL
  // =========================================================

  const handleCloseModal = () => {
    setShowModal(false);
    setShowMapping(false);
    setSelectedRow(null);
  };

  // =========================================================
  // FORM CHANGE
  // =========================================================

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((previous) => ({
      ...previous,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // =========================================================
  // SAVE MAPPING
  // =========================================================

  const handleSave = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    try {
      const country = formData.country.trim();
      const league = formData.league.trim();
      const normalized = formData.normalized.trim();
      const dom_short = formData.dom_short.trim();
      const team_code = formData.team_code.trim();

      // Check for empty required fields
      if (!country || !league || !normalized || !dom_short || !team_code) {
        alert("Please fill in all fields.");
        return;
      }

      const payload = {
        country: formData.country.trim().toLowerCase(),

        league: formData.league.trim().toLowerCase(),

        normalized: formData.normalized.trim().toLowerCase(),

        dom_short: formData.dom_short.trim().toUpperCase(),

        inclusion: formData.inclusion,
        teamcode: team_code,
      };

      console.log("Saving mapping:", payload);

      const response = await fetch(
        `${FAST_AP_LINK}/update_league_mappings/json_data`,
        {
          method: "PUT",

          headers: {
            "Content-Type": "application/json",
          },

          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to save mapping");
      }

      // await fetchRejectedLinks();

      setShowMapping(false);

      handleCloseModal();
    } catch (error) {
      console.error("Error saving mapping:", error);
    }
  };

  // =========================================================
  // ESCAPE KEY
  // =========================================================

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape" && showModal) {
        handleCloseModal();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [showModal]);

  // =========================================================
  // DRAG START
  // =========================================================

  const handleDragStart = (event) => {
    if (!mappingRef.current || !modalRef.current) {
      return;
    }

    const panel = mappingRef.current.getBoundingClientRect();

    dragData.current = {
      dragging: true,
      offsetX: event.clientX - panel.left,
      offsetY: event.clientY - panel.top,
    };

    event.currentTarget.setPointerCapture(event.pointerId);
  };

  // =========================================================
  // DRAG MOVE
  // =========================================================

  const handleDragMove = (event) => {
    if (
      !dragData.current.dragging ||
      !modalRef.current ||
      !mappingRef.current
    ) {
      return;
    }

    const modal = modalRef.current.getBoundingClientRect();

    const panel = mappingRef.current.getBoundingClientRect();

    let x = event.clientX - modal.left - dragData.current.offsetX;

    let y = event.clientY - modal.top - dragData.current.offsetY;

    // Keep panel inside modal horizontally
    const maxX = modal.width - panel.width;

    // Keep panel inside modal vertically
    const maxY = modal.height - panel.height;

    x = Math.max(0, Math.min(x, maxX));

    y = Math.max(0, Math.min(y, maxY));

    setMappingPosition({
      x,
      y,
    });
  };

  // =========================================================
  // DRAG END
  // =========================================================

  const handleDragEnd = (event) => {
    dragData.current.dragging = false;

    try {
      event.currentTarget.releasePointerCapture(event.pointerId);
    } catch {
      // Pointer capture may already be released
    }
  };

  // =========================================================
  // MAPPING PANEL STYLE
  // =========================================================

  const mappingStyle =
    mappingPosition.x !== null && mappingPosition.y !== null
      ? {
          left: `${mappingPosition.x}px`,
          top: `${mappingPosition.y}px`,
          right: "auto",
        }
      : {};

  // =========================================================
  // RENDER
  // =========================================================

  return (
    <>
      {/* =====================================================
          MAIN CARD
          ===================================================== */}

      <div className="alg1_card rejected_links">
        <div className="rejected-header">
          <div className="rejected-title">
            <h2>Rejected Links</h2>

            <span className="rejected-count">
              {rejectedLinks.length} records
            </span>
          </div>
          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            <button
              className="refresh-btn"
              onClick={fetchRejectedLinks}
              disabled={loading}
            >
              {loading ? "Loading..." : "Refresh"}
            </button>

            <button
              className="refresh-btn"
              onClick={handleDeleteAll}
              style={{
                background: "#b91c1c",
                color: "#fff",
              }}
            >
              Delete All
            </button>
          </div>
        </div>

        {/* ===================================================
            TABLE
            =================================================== */}

        {loading ? (
          <div className="loading">Loading rejected links...</div>
        ) : rejectedLinks.length === 0 ? (
          <div className="empty">No rejected links found.</div>
        ) : (
          <div className="table-container">
            <table className="rejected-table">
              <thead>
                <tr>
                  <th>Team Code</th>
                  <th>Country</th>
                  <th>League</th>
                  <th>Reason</th>
                  <th>Result</th>
                  <th>Standings</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {rejectedLinks.map((row, index) => (
                  <tr key={row.team_code || index}>
                    <td>{row.team_code || "-"}</td>

                    <td>{row.country || "-"}</td>

                    <td>{row.league || "-"}</td>

                    <td className="reason">{row.reason || "-"}</td>

                    <td>
                      <a
                        href={row.result_url}
                        target="_blank"
                        rel="noreferrer"
                        className="url-link"
                      >
                        Open
                      </a>
                    </td>

                    <td>
                      <a
                        href={row.standings_url}
                        target="_blank"
                        rel="noreferrer"
                        className="url-link"
                      >
                        Open
                      </a>
                    </td>

                    <td>
                      <button
                        className="view-btn"
                        onClick={() => handleOpenModal(row)}
                      >
                        View / Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* =====================================================
          MODAL
          ===================================================== */}

      {showModal && selectedRow && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div
            ref={modalRef}
            className="rejected-modal"
            onClick={(e) => e.stopPropagation()}
          >
            {/* =================================================
                  MODAL HEADER
                  ================================================= */}

            <div className="modal-header">
              <div className="modal-header-left">
                <div className="modal-heading">
                  <h2>Rejected Link</h2>

                  <span className="modal-team-code">
                    {selectedRow.team_code || "-"}
                  </span>
                </div>

                {/* =============================================
                      REJECTED INFORMATION IN HEADER
                      ============================================= */}

                <div className="header-rejected-info">
                  <div className="header-info-item">
                    <span className="header-info-label">Home</span>

                    <span className="header-info-value">
                      {selectedRow.home_team || "-"}
                    </span>
                  </div>

                  <div className="header-info-item">
                    <span className="header-info-label">Away</span>

                    <span className="header-info-value">
                      {selectedRow.away_team || "-"}
                    </span>
                  </div>

                  <div className="header-info-item">
                    <span className="header-info-label">Country</span>

                    <span className="header-info-value">
                      {selectedRow.country || "-"}
                    </span>
                  </div>

                  <div className="header-info-item">
                    <span className="header-info-label">League</span>

                    <span className="header-info-value">
                      {selectedRow.league || "-"}
                    </span>
                  </div>

                  <div className="header-info-item reason-header-item">
                    <span className="header-info-label">Reason</span>

                    <span className="header-info-value">
                      {selectedRow.reason || "-"}
                    </span>
                  </div>
                </div>
              </div>

              {/* =============================================
                    HEADER ACTIONS
                    ============================================= */}

              <div className="modal-header-actions">
                <button
                  className={
                    showMapping ? "mapping-toggle active" : "mapping-toggle"
                  }
                  onClick={() => setShowMapping((previous) => !previous)}
                >
                  {showMapping ? "Hide Mapping" : "League Mapping"}
                </button>

                <button className="close-btn" onClick={handleCloseModal}>
                  ×
                </button>
              </div>
            </div>

            {/* =================================================
                  MODAL BODY
                  ================================================= */}

            <div className="modal-body">
              <div className="modal-main-content">
                {/* =============================================
                      ROW 1
                      RESULT + STANDINGS
                      ============================================= */}

                <div className="pages-row">
                  {/* RESULT */}

                  <section className="modal-section page-section">
                    <div className="section-title-row">
                      <h3>Result Page</h3>

                      <a
                        href={selectedRow.result_url}
                        target="_blank"
                        rel="noreferrer"
                        className="open-external"
                      >
                        Open ↗
                      </a>
                    </div>

                    <div className="page-url">{selectedRow.result_url}</div>

                    <div className="embedded-page">
                      <iframe
                        src={selectedRow.result_url}
                        title="Result page"
                        loading="eager"
                      />
                    </div>
                  </section>

                  {/* STANDINGS */}
                  <section className="modal-section page-section">
                    <div className="section-title-row">
                      <h3>Standings Page</h3>

                      <a
                        href={selectedRow.standings_url}
                        target="_blank"
                        rel="noreferrer"
                        className="open-external"
                      >
                        Open ↗
                      </a>
                    </div>

                    <div className="page-url">{selectedRow.standings_url}</div>

                    <div className="embedded-page">
                      <iframe
                        src={selectedRow.standings_url}
                        title="Standings page"
                        loading="eager"
                      />
                    </div>
                  </section>
                </div>
              </div>
            </div>

            {/* =================================================
                  FLOATING LEAGUE MAPPING
                  ================================================= */}

            {showMapping && (
              <div
                ref={mappingRef}
                className="floating-mapping"
                style={mappingStyle}
              >
                {/* DRAG HEADER */}

                <div
                  className="floating-mapping-header"
                  onPointerDown={handleDragStart}
                  onPointerMove={handleDragMove}
                  onPointerUp={handleDragEnd}
                  onPointerCancel={handleDragEnd}
                >
                  <div>
                    <span className="drag-handle">⋮⋮</span>

                    <span>League Mapping</span>
                  </div>

                  <button
                    className="floating-close"
                    onPointerDown={(e) => e.stopPropagation()}
                    onClick={() => setShowMapping(false)}
                  >
                    ×
                  </button>
                </div>

                {/* MAPPING BODY */}

                <div className="floating-mapping-body">
                  <div className="mapping-form">
                    {/* COUNTRY */}

                    <div className="form-group">
                      <label>Country</label>

                      <input
                        type="text"
                        name="country"
                        value={formData.country}
                        onChange={handleChange}
                        placeholder="e.g. poland"
                      />
                    </div>

                    {/* LEAGUE */}

                    <div className="form-group">
                      <label>League</label>

                      <input
                        type="text"
                        name="league"
                        value={formData.league}
                        onChange={handleChange}
                        placeholder="e.g. ekstraklasa"
                      />
                    </div>

                    {/* NORMALIZED */}

                    <div className="form-group">
                      <label>Normalized</label>

                      <input
                        type="text"
                        name="normalized"
                        value={formData.normalized}
                        onChange={handleChange}
                        placeholder="e.g. ekstraklasa"
                      />
                    </div>

                    {/* DOM SHORT */}

                    <div className="form-group">
                      <label>DOM Short</label>

                      <input
                        type="text"
                        name="dom_short"
                        value={formData.dom_short}
                        onChange={handleChange}
                        placeholder="e.g. EKS"
                      />
                    </div>

                    {/* INCLUSION */}

                    <div className="inclusion-row">
                      <div className="inclusion-text">
                        <span className="inclusion-label">Include League</span>

                        <span className="inclusion-description">
                          Enable this league for processing
                        </span>
                      </div>

                      <label className="switch">
                        <input
                          type="checkbox"
                          name="inclusion"
                          checked={formData.inclusion}
                          onChange={handleChange}
                        />

                        <span className="slider"></span>
                      </label>

                      <span
                        className={
                          formData.inclusion ? "status-on" : "status-off"
                        }
                      >
                        {formData.inclusion ? "Included" : "Excluded"}
                      </span>
                    </div>
                  </div>
                </div>

                {/* MAPPING FOOTER */}

                <div className="floating-mapping-footer">
                  <button
                    className="cancel-btn"
                    onClick={() => setShowMapping(false)}
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="save-btn"
                    onClick={handleSave}
                  >
                    Save Mapping
                  </button>
                </div>
              </div>
            )}

            {/* =================================================
                  MODAL FOOTER
                  ================================================= */}

            <div className="modal-footer">
              <button
                type="button"
                className="cancel-btn"
                onClick={handleCloseModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
